import { createApp } from 'vue'
import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/styles/index.scss'
import '@/styles/reset.scss'
import '@/styles/goods.scss'
import 'vant/lib/index.css' // 全局引入样式
import 'amfe-flexible'
import vant from 'vant'
import './permission'
import directive from './directive' // directive
import { onToast, onToastSucc, onToastFail } from './utils/toast'
import { productRouter, adRouter, goodsRouter, menuRouter, funcRouter, customerService } from '@/utils/toRouter'
import { updateAdClick } from './api/base'
import { trackContent } from '@/utils/contentTrack'
import { formatMoney, parseTime, validPhone, formatValue, px2rem, imgWEBP, isApp } from '@/utils/common'
import appJS from '@/utils/appJS'
import VueClipboard from 'vue3-clipboard'
import global from '@/constant/Global'
import '@/assets/font/index.css' // 字体导入
import '@/utils/IsIphoneX'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import NavigationBar from '@/components/NavigationBar'
import FooterFiexd from '@/components/FooterFiexd'
import VConsole from 'vconsole'
import Vue3Marquee from 'vue3-marquee'

const isIOSDevice = () => {
  const ua = navigator.userAgent || ''
  return /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1)
}
const isIPadDevice = () => {
  const ua = navigator.userAgent || ''
  return /ipad/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1)
}
const isIosUniShell = isIOSDevice() && /Html5Plus/i.test(navigator.userAgent)
const isAlipayMiniProgram = () => {
  const ua = navigator.userAgent || ''
  return !isApp() && /AlipayClient/i.test(ua) && !/Html5Plus/i.test(ua)
}
const isWechatMiniProgram = () => {
  return !isApp() && window.__wxjs_environment === 'miniprogram'
}
const IPAD_UNI_SHELL_MAX_BOTTOM_OFFSET = 24
const syncShellLayoutVars = () => {
  const viewportHeights = [window.innerHeight, document.documentElement?.clientHeight, window.visualViewport?.height].filter(
    (value) => typeof value === 'number' && value > 0
  )
  const screenHeight = typeof window.screen?.height === 'number' ? window.screen.height : 0
  const shellHeight =
    isIosUniShell && screenHeight ? Math.min(...viewportHeights, screenHeight) : viewportHeights.length ? Math.min(...viewportHeights) : 0
  const measuredBottomOffset =
    isIosUniShell && screenHeight && viewportHeights.length ? Math.max(Math.max(...viewportHeights) - screenHeight, 0) : 0
  const fixedBottomOffset =
    isIosUniShell && isIPadDevice() ? Math.min(measuredBottomOffset, IPAD_UNI_SHELL_MAX_BOTTOM_OFFSET) : measuredBottomOffset
  const alipayMiniProgram = isAlipayMiniProgram()
  const miniProgram = alipayMiniProgram || isWechatMiniProgram()

  document.documentElement.classList.toggle('ios-uni-shell', isIosUniShell)
  document.documentElement.classList.toggle('alipay-mini-program', alipayMiniProgram)
  document.documentElement.style.setProperty('--app-navigation-top-offset', miniProgram ? '0px' : '34px')
  document.documentElement.style.setProperty('--app-page-nav-top-offset', miniProgram ? '0px' : '30px')
  document.documentElement.style.setProperty('--app-iphonex-top-offset', miniProgram ? '0px' : '44px')
  document.documentElement.style.setProperty('--app-scroll-nav-wrapper-height', alipayMiniProgram ? '44px' : '69px')
  document.documentElement.style.setProperty('--app-scroll-page-top-offset', alipayMiniProgram ? '44px' : '74px')
  document.documentElement.style.setProperty('--app-scroll-page-iphonex-top-offset', alipayMiniProgram ? '44px' : '88px')
  document.documentElement.style.setProperty('--app-home-header-top-offset', alipayMiniProgram ? '0px' : 'max(36px, calc(-2px + env(safe-area-inset-top, 0px)))')
  document.documentElement.style.setProperty('--app-home-header-spacer-height', alipayMiniProgram ? '64px' : 'calc(48px + max(56px, calc(18px + env(safe-area-inset-top, 0px))))')
  document.documentElement.style.setProperty('--app-my-page-bg-height', alipayMiniProgram ? '190px' : '220px')
  document.documentElement.style.setProperty('--app-member-page-content-top-offset', alipayMiniProgram ? '50px' : '80px')
  document.documentElement.style.setProperty('--app-member-page-content-iphonex-top-offset', alipayMiniProgram ? '50px' : '94px')
  document.documentElement.style.setProperty('--app-goods-detail-back-top-offset', alipayMiniProgram ? '12px' : '40px')
  document.documentElement.style.setProperty('--app-cash-loan-content-top-offset', alipayMiniProgram ? '44px' : '74px')
  document.documentElement.style.setProperty('--app-product-index-top-padding', alipayMiniProgram ? '44px' : '90px')
  document.documentElement.style.setProperty('--app-consumer-header-top-offset', alipayMiniProgram ? '0px' : '40px')
  document.documentElement.style.setProperty('--app-consumer-header-iphonex-top-offset', alipayMiniProgram ? '0px' : '51px')
  document.documentElement.style.setProperty('--app-mall-bg-top-padding', alipayMiniProgram ? '38px' : '68px')
  document.documentElement.style.setProperty('--app-mall-bg-top-iphonex-padding', alipayMiniProgram ? '38px' : '90px')
  document.documentElement.style.setProperty('--app-third-mall-header-top-padding', alipayMiniProgram ? '12px' : 'calc(env(safe-area-inset-top, 0px) + 34px)')
  if (shellHeight > 0) {
    document.documentElement.style.setProperty('--app-shell-height', `${Math.round(shellHeight)}px`)
  }
  document.documentElement.style.setProperty('--app-fixed-bottom-offset', `${Math.round(fixedBottomOffset)}px`)
}

syncShellLayoutVars()
window.addEventListener('resize', syncShellLayoutVars)
window.addEventListener('orientationchange', syncShellLayoutVars)
window.addEventListener('pageshow', syncShellLayoutVars)
window.visualViewport?.addEventListener('resize', syncShellLayoutVars)

if (import.meta.env.VITE_APP_ENV !== 'production') {
  const getVConsoleViewportSize = () => {
    const heights = [window.innerHeight, document.documentElement?.clientHeight, window.visualViewport?.height].filter(
      (value) => typeof value === 'number' && value > 0
    )
    return {
      width: Math.round(window.visualViewport?.width || window.innerWidth || document.documentElement?.clientWidth || 0),
      height: Math.round(heights.length ? Math.min(...heights) : window.innerHeight)
    }
  }
  const syncVConsoleSwitchPosition = (instance) => {
    if (!instance) return
    const switchSize = 54
    const rightOffset = 12
    const viewport = getVConsoleViewportSize()
    const topOffset = Math.max(Math.round((viewport.height - switchSize) / 2), 120)
    const leftOffset = Math.max(viewport.width - switchSize - rightOffset, 12)
    instance.setSwitchPosition(leftOffset, topOffset)
  }
  // eslint-disable-next-line no-unused-vars
  var vConsole = new VConsole({
    theme: 'light',
    maxLogNumber: 1000,
    onReady() {
      syncVConsoleSwitchPosition(this)
    }
  })
  window.addEventListener('resize', () => {
    syncVConsoleSwitchPosition(vConsole)
  })
  window.addEventListener('orientationchange', () => {
    syncVConsoleSwitchPosition(vConsole)
  })
  window.visualViewport?.addEventListener('resize', () => {
    syncVConsoleSwitchPosition(vConsole)
  })
}
// svg图标
import 'virtual:svg-icons-register'
import SvgIcon from '@/components/SvgIcon'
// 注册指令
import plugins from './plugins' // plugins
import { Lazyload } from 'vant'
const app = createApp(App)

// 全局方法挂载
app.config.globalProperties.onToast = onToast
app.config.globalProperties.onToastSucc = onToastSucc
app.config.globalProperties.onToastFail = onToastFail
app.config.globalProperties.formatMoney = formatMoney
app.config.globalProperties.validPhone = validPhone
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.formatValue = formatValue
app.config.globalProperties.updateAdClick = updateAdClick
app.config.globalProperties.$trackContent = trackContent
app.config.globalProperties.$global = global
app.config.globalProperties.$productRouter = productRouter
app.config.globalProperties.$adRouter = adRouter
app.config.globalProperties.$goodsRouter = goodsRouter
app.config.globalProperties.$menuRouter = menuRouter
app.config.globalProperties.$funcRouter = funcRouter
app.config.globalProperties.$px2rem = px2rem
app.config.globalProperties.$customerService = customerService
app.config.globalProperties.appJS = appJS
app.config.globalProperties.$imgWEBP = imgWEBP
// 全局变量挂载
app.config.globalProperties.$env={
  appName: import.meta.env.VITE_APP_TITLE
}
directive(app)
app.use(router)
app.use(store)
app.use(VueDOMPurifyHTML)
app.use(Vue3Marquee)
app.use(Lazyload)
app.use(VueClipboard, {
  autoSetContainer: true
})
app.use(vant)
app.use(plugins)
app.component('SvgIcon', SvgIcon)
app.component('NavigationBar', NavigationBar)
app.component('FooterFiexd', FooterFiexd)
app.mount('#app')
